<template>
  <modalForm :title="$t('flow.addReason')" :submit-label="$t('actions.add')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel">
    <div v-if="error" class="text-red-600 text-sm font-bold mt-4">{{error}}</div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('flow.reason') }}:</p>
      <input type="text" name="reason" v-model="reason" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm ">
      <div v-for="error of v$.reason.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import modalForm from '../../building_blocks/modalForm'
import formViewMixin from '../../building_blocks/formViewMixin'
import reasonModel from '@/models/reason'

import { useReasonForResolvingStore } from '@/stores/reasonForResolving';

export default {
  mixins: [formViewMixin],
  name: 'ReasonAdd',
  setup () {
    let reasonStore = useReasonForResolvingStore();
    return { v$: useVuelidate(), reasonStore };
  },
  components: {
    modalForm,
  },
  methods: {
    async onFormValid() {
      this.error = '';
      let data = reasonModel.buildCreate(this.reason);
      let response;
      try {
        response = await reasonModel.createReason(data, this.axios, this.$root.token);
      } catch(error) {
        this.error = this.$t('flow.addReasonError');
      }
      if (response && response.status === 201) {
        let reason = response.data.data;
        this.reasonStore.replaceOrAdd(reason);
        this.$emit('add-finished-event');
      }
    },
    cancel() {
      this.$emit('add-finished-event');
    },
  },
  data() {
    return {
      'reason': '',
      'error': undefined,
    }
  },
  validations () {
    return {
      'reason': { required },
    }
  }
}
</script>
